import React, { Component } from "react";
import ReactDOM from "react-dom";

import Icon from "./../static/icon";

import styles from "./dropDown.module.scss";

class DropDown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: !!props.isOpen ? props.isOpen : false,
    };

    this.handleDropDownToggleOut = this.handleDropDownToggleOut.bind(this);
  }

  componentDidUpdate() {
    if (this.state.isOpen) {
      document.addEventListener("click", this.handleDropDownToggleOut, false);
    } else {
      document.removeEventListener("click", this.handleDropDownToggleOut, false);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleDropDownToggleOut, false);
  }

  handleDropDownToggle() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  handleDropDownToggleOut(event) {
    const domNode = ReactDOM.findDOMNode(this.refs.logout);
    if (!domNode || !domNode.contains(event.target)) {
      this.setState({
        open: false,
      });
    }
  }

  render() {
    const { button, content } = this.props;
    return (
      <div className={styles.dropDown}>
        <button
          className={this.state.isOpen ? styles.dropDownButton_open : styles.dropDownButton_close}
          onClick={(e) => {
            e.stopPropagation();
            this.handleDropDownToggle();
          }}
        >
          {button}
          <span className={styles.icon}>
            <Icon name="direction-desc" />
          </span>
        </button>

        <div ref="logout" className={this.state.isOpen ? styles.dropDownItems_open : styles.dropDownItems_close}>
          {content}
        </div>
      </div>
    );
  }
}

export default DropDown;
